/**
 * cryptoJS
 */
import { decrypt, encrypt } from "../libs/crypto";

// 获取user信息
let user = undefined;
if (localStorage.getItem("user")) {
    user = JSON.parse(
        decrypt(localStorage.getItem("user"), "aTaoke in localhost")
    );
    if (user.timer <= new Date().getTime() + 15 * 60 * 1000) {
        localStorage.removeItem("user");
        user = undefined;
    }
}

const state = {
    info: {
        name: "Home",
        title: "Home",
        page: "Home",
        keyword: "Home",
        description: "Home",
        showHeader: true,
        showFooter: true
    },
    user: user
};

const mutations = {
    title: function(state, title) {
        state.site.page = title;
    },
    login: function(state, user) {
        user.timer = new Date().getTime();
        localStorage.setItem(
            "user",
            encrypt(JSON.stringify(user), "aTaoke in localhost")
        );
        state.user = user;
    },
    logout: function(state) {
        state.user = undefined;
        localStorage.removeItem("user");
    },
    head: function(state, val = true) {
        state.site.showHeader = val;
    },
    foot: function(state, val = true) {
        state.site.showFooter = val;
    }
};

const actions = {};

export default {
    state,
    mutations,
    actions
};